import {
  AuthenticationDetails,
  IccAccesslogApi,
  IccAuthApi,
  IccCodeApi, IccFormApi,
  IccGroupApi,
  IccHcpartyXApi,
  IccIcureApi,
  IccInsuranceApi,
  IccTarificationApi,
  IccUserXApi,
  IcureBasicApi,
  XHR
} from "@icure/api";
// @ts-ignore
import {Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {IcureTokensHelper} from "../helper/icure-tokens.helper";

export interface ErrorHandlingIccApi {
  handleError: (err: XHR.XHRError) => never;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public hcPartyApi!: IccHcpartyXApi;
  public userApi!: IccUserXApi;

  public authApi!: IccAuthApi;
  public groupApi!: IccGroupApi;
  public accessLogApi!: IccAccesslogApi;
  public codeApi!: IccCodeApi;
  public tarificationApi!: IccTarificationApi;
  public insuranceApi!: IccInsuranceApi;
  public icureApi!: IccIcureApi;
  public formApi!: IccFormApi;

  constructor(
    private router: Router
  ) {
  }

  public async reconfigure(
    host: string,
    authProvider: AuthenticationDetails
  ): Promise<void> {

    const iccApis: IcureBasicApi = await IcureBasicApi.initialise(
      host,
      authProvider
    )
      .catch(error => {
        this.handleIcureApiInitialisationFailed(error);
        throw error;
      });

    this.authApi = this.patchErrorHandler(iccApis.authApi);
    this.hcPartyApi = this.patchErrorHandler(iccApis.healthcarePartyApi);
    this.userApi = this.patchErrorHandler(iccApis.userApi);
    this.icureApi = this.patchErrorHandler(iccApis.icureApi);
    this.groupApi = this.patchErrorHandler(iccApis.groupApi);
    this.accessLogApi = this.patchErrorHandler(iccApis.accessLogApi);
    this.codeApi = this.patchErrorHandler(iccApis.codeApi);
    this.tarificationApi = this.patchErrorHandler(iccApis.pricingApi);
    this.insuranceApi = this.patchErrorHandler(iccApis.insuranceApi);
    this.formApi = this.patchErrorHandler(iccApis.formApi);

    // @ts-ignore
    window['iccApi'] = this;
  }

  protected patchErrorHandler<T extends ErrorHandlingIccApi>(instance: T): T {
    const that = this;
    instance['handleError'] = function handleErrorPatched(err: XHR.XHRError) {
      if (err.statusCode === 401) {
        if (!['/'].includes(that.router.url.split('?')[0])) {
          that.router.navigate(['/']);
        }
      }
      throw err;
    };
    return instance;
  }

  private handleIcureApiInitialisationFailed(error: any): void {
    console.log('Failed to initialize IcureApi', error);
    IcureTokensHelper.deleteAll();
    this.router.navigate(['/']);
  }
}


